<template>
    <div class="title-block">
        <div class="title-block__title">
            Настройка доступа
        </div>
    </div>
    <div class="access-config-edit mb-4">
        <div class="access-config-roles">
            <div class="access-config-roles__title">Список ролей</div>
            <div class="access-config-roles__box">
                <ul class="access-config-roles-list">
                    <li class="access-config-roles-item">
                        <div class="access-config-roles-item__title">Администратор</div>
                        <div class="d-flex justify-content-end align-items-center">
                            <button class="content-control edit reset-btn" title="Редактировать"></button>
                            <button class="content-control delete reset-btn" title="Удалить"></button>
                        </div>
                    </li>
                    <li class="access-config-roles-item">
                        <div class="access-config-roles-item__title">Техническая поддержка</div>
                        <div class="d-flex justify-content-end align-items-center">
                            <button class="content-control edit reset-btn" title="Редактировать"></button>
                            <button class="content-control delete reset-btn" title="Удалить"></button>
                        </div>
                    </li>
                    <li class="access-config-roles-item">
                        <div class="access-config-roles-item__title">Менеджер клиента</div>
                        <div class="d-flex justify-content-end align-items-center">
                            <button class="content-control edit reset-btn" title="Редактировать"></button>
                            <button class="content-control delete reset-btn" title="Удалить"></button>
                        </div>
                    </li>
                    <li class="access-config-roles-item">
                        <div class="access-config-roles-item__title">Менеджер <b>DS</b></div>
                        <div class="d-flex justify-content-end align-items-center">
                            <button class="content-control edit reset-btn" title="Редактировать"></button>
                            <button class="content-control delete reset-btn" title="Удалить"></button>
                        </div>
                    </li>
                    <li class="access-config-roles-item">
                        <div class="access-config-roles-item__title">Программист</div>
                        <div class="d-flex justify-content-end align-items-center">
                            <button class="content-control edit reset-btn" title="Редактировать"></button>
                            <button class="content-control delete reset-btn" title="Удалить"></button>
                        </div>
                    </li>
                    <li class="access-config-roles-item">
                        <div class="access-config-roles-item__title">Прочее</div>
                        <div class="d-flex justify-content-end align-items-center">
                            <button class="content-control edit reset-btn" title="Редактировать"></button>
                            <button class="content-control delete reset-btn" title="Удалить"></button>
                        </div>
                    </li>
                </ul>
                <button class="reset-btn access-config-roles-add-btn">
                    Добавить роль
                </button>
            </div>
            <button class="btn access-config-roles-add-usr-btn">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M15.385 7.385h-6.77V.615a.615.615 0 10-1.23 0v6.77H.615A.615.615 0 000 8a.56.56 0 00.616.578h6.769v6.807a.616.616 0 001.23 0v-6.77h6.77a.616.616 0 000-1.23z"
                        fill="currentColor" />
                </svg>
                <span>Добавить пользователя</span>
            </button>
        </div>
    </div>
    <div class="access-config-users">
        <div class="access-config-users__title">
            Список пользователей
        </div>
        <div class="table-responsive">
            <table class="access-config-table  table">
                <thead>
                    <tr>
                        <th>Имя пользователя</th>
                        <th>
                            <div class="d-flex justify-content-start">
                                <v-select
                                    v-model="role"
                                    :items="['Администратор', 'Программист', 'Менеджер DS', 'Менеджер клиента']"
                                    variant="outlined"
                                    color="primary"
                                    density="compact"
                                    clearable
                                    @update:menu="$removeFocus"
                                    @click:clear="$removeFocus"
                                    @click:control="$removeFocus">
                                    <template #no-data>
                                        <v-list-item>
                                            <span>Данные не найдены</span>
                                        </v-list-item>
                                    </template>
                                </v-select>
                            </div>
                        </th>
                        <th>Электронная почта</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            Евгений Евгеньев
                        </td>
                        <td>
                            Администратор (трансляции)
                        </td>
                        <td>
                            <a class="hover-underline" href="mailto:pochta@gmail.com">pochta@gmail.com</a>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end align-items-center">
                                <button class="reset-btn content-control table-row-control edit"></button>
                                <button class="reset-btn content-control table-row-control delete"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Евгений Евгеньев
                        </td>
                        <td>
                            Администратор (трансляции)
                        </td>
                        <td>
                            <a class="hover-underline" href="mailto:pochta@gmail.com">pochta@gmail.com</a>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end align-items-center">
                                <button class="reset-btn content-control table-row-control edit"></button>
                                <button class="reset-btn content-control table-row-control delete"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Евгений Евгеньев
                        </td>
                        <td>
                            Администратор (трансляции)
                        </td>
                        <td>
                            <a class="hover-underline" href="mailto:pochta@gmail.com">pochta@gmail.com</a>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end align-items-center">
                                <button class="reset-btn content-control table-row-control edit"></button>
                                <button class="reset-btn content-control table-row-control delete"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Евгений Евгеньев
                        </td>
                        <td>
                            Администратор (трансляции)
                        </td>
                        <td>
                            <a class="hover-underline" href="mailto:pochta@gmail.com">pochta@gmail.com</a>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end align-items-center">
                                <button class="reset-btn content-control table-row-control edit"></button>
                                <button class="reset-btn content-control table-row-control delete"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Евгений Евгеньев
                        </td>
                        <td>
                            Администратор (трансляции)
                        </td>
                        <td>
                            <a class="hover-underline" href="mailto:pochta@gmail.com">pochta@gmail.com</a>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end align-items-center">
                                <button class="reset-btn content-control table-row-control edit"></button>
                                <button class="reset-btn content-control table-row-control delete"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Евгений Евгеньев
                        </td>
                        <td>
                            Администратор (трансляции)
                        </td>
                        <td>
                            <a class="hover-underline" href="mailto:pochta@gmail.com">pochta@gmail.com</a>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end align-items-center">
                                <button class="reset-btn content-control table-row-control edit"></button>
                                <button class="reset-btn content-control table-row-control delete"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Евгений Евгеньев
                        </td>
                        <td>
                            Администратор (трансляции)
                        </td>
                        <td>
                            <a class="hover-underline" href="mailto:pochta@gmail.com">pochta@gmail.com</a>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end align-items-center">
                                <button class="reset-btn content-control table-row-control edit"></button>
                                <button class="reset-btn content-control table-row-control delete"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Евгений Евгеньев
                        </td>
                        <td>
                            Администратор (трансляции)
                        </td>
                        <td>
                            <a class="hover-underline" href="mailto:pochta@gmail.com">pochta@gmail.com</a>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end align-items-center">
                                <button class="reset-btn content-control table-row-control edit"></button>
                                <button class="reset-btn content-control table-row-control delete"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Евгений Евгеньев
                        </td>
                        <td>
                            Администратор (трансляции)
                        </td>
                        <td>
                            <a class="hover-underline" href="mailto:pochta@gmail.com">pochta@gmail.com</a>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end align-items-center">
                                <button class="reset-btn content-control table-row-control edit"></button>
                                <button class="reset-btn content-control table-row-control delete"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Евгений Евгеньев
                        </td>
                        <td>
                            Администратор (трансляции)
                        </td>
                        <td>
                            <a class="hover-underline" href="mailto:pochta@gmail.com">pochta@gmail.com</a>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end align-items-center">
                                <button class="reset-btn content-control table-row-control edit"></button>
                                <button class="reset-btn content-control table-row-control delete"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Евгений Евгеньев
                        </td>
                        <td>
                            Администратор (трансляции)
                        </td>
                        <td>
                            <a class="hover-underline" href="mailto:pochta@gmail.com">pochta@gmail.com</a>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end align-items-center">
                                <button class="reset-btn content-control table-row-control edit"></button>
                                <button class="reset-btn content-control table-row-control delete"></button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>

<script>
import PaginationElement from "../../../elements/PaginationElement";
export default {
    name: "AccessConfiguration",
    components: {
        PaginationElement,
    },
    data: () => {
        return {
            role: 'Роль'
        };
    },
};
</script>
